import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';

const TribunPlayModal = props => {

  /*const buttonConfig = {
    primary: {
      label: EnvironmentManager.getMessageText({ key: 'tribun_clean_add' }),
      onClick: props.onPrimaryButtonClick
    }
  };*/

  const { errorMessage } = props;

  const message = errorMessage ? errorMessage : EnvironmentManager.getMessageText({ key: 'tribune_add_odds_extra_description' });

  return (
    <Message type="none">
      <p dangerouslySetInnerHTML={ { __html: message } } />
    </Message>
  );
};

TribunPlayModal.propTypes = {
  errorMessage: PropTypes.string
};

export default TribunPlayModal;
